import React, { useState, useEffect, useRef } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import * as videos from '../shared/video-list';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Col, Form, Row } from 'react-bootstrap';
import { Password } from "primereact/password";



export default function ShowVideo(props) {
    const toast = useRef(null);
    const [showVideo, setShowVideo] = useState(false);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [padTop, setPadTop] = useState(40);
   
    const video = videos.getVideo(props.videoId);

    useEffect(() => {
      if(props.top != 10) setPadTop(5);
    }, []);

    return(      
      <>
      {
        (video==null)? <></>:
        <div style={{position:"fixed", top:props.top+"px", right:"10px", width:"115px", zIndex:"1000"}}>
          {
            showVideo?
          <div onClick={()=>setShowVideo(false)} style={{cursor:"pointer", fontSize:"8pt", color:"royalblue"}}>
            <i className="bi bi-x me-2" style={{cursor:"pointer", position:"absolute", top:"-5px", fontSize:"20pt", right:"0px"}}></i>
            <label style={{cursor:"pointer", position:"absolute", top:"0px", right:"32px", fontSize:"9pt"}}>بستن ویدئو</label>
          </div>
            :
          <div onClick={()=>setShowVideo(true)} style={{cursor:"pointer", fontSize:"8pt", color:"royalblue"}}><img src={require('../lib/images/play-video-icon.png')} style={{width:"32px", height:"24px"}} title={video.title} />راهنما</div>
          }
        </div>
      }
      {
        showVideo?
        <Row style={{paddingTop:padTop+"px"}}>
          <Col md={props.md} style={{position:"relative"}}>
            <span style={{display: "block", paddingTop: "57%"}}></span>
            <iframe style={{position:"absolute", top:"0", right:10, width:"calc(100% - 20px)", height:"100%"}} src={"https://www.aparat.com/video/video/embed/videohash/"+video.code+"/vt/frame"}  allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
          </Col>        
        </Row>
        :<></>
      }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <Toast ref={toast} />            
      </>  
    );
  
}
